// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"8e5647ce","722":"4f259bf6","843":"1c14c806","881":"67714fc6"}[chunkId] + ".chunk.css";
};